export interface IDistDef<T> {
  value: T;
  probability: number;
}

export class Distribution<T> {
  private readonly probs: number[];

  constructor(private def: IDistDef<T>[]) {
    this.probs = [];
    let val = 0;
    def.forEach(d => {
      val += d.probability;
      this.probs.push(val);
    });
  }

  get total(): number { return this.probs[this.probs.length - 1 ]; }
  random(): T {
    const random = Math.random() * this.total;
    const idx = this.probs.findIndex(v => v > random);
    return this.def[idx].value;
  }
}
